import AchievementComponent from "./AchievementComponent";

const Achievements = ({ achievements, siteTheme, isDay }) => {
  return (
    <div
      className={`${
        isDay ? siteTheme.textColor : "text-neutral-400"
      } flex flex-col items-center justify-center w-full px-2 md:px-5 lg:px-0 mx-auto max-w-max-profile-content-width mb-20`}
    >
      <div className="relative flex flex-row items-center w-full mb-5">
        <div className="mr-2 flex-[0.5] h-[1px] bg-gradient-to-r from-transparent to-linesLight" />
        <p
          className={`flex-[1] text-lg sm:text-2xl text-center font-semibold uppercase w-fit ${siteTheme.textColor}`}
        >
          Enterprise-Grade Application
        </p>
        <div className="ml-2 flex-[0.5] h-[1px] bg-gradient-to-r from-linesLight to-transparent" />
      </div>
      <div className="columns-1">
        {achievements.map((achievement, idx) => (
          <AchievementComponent
            key={idx}
            achievement={achievement}
            isDay={isDay}
          />
        ))}
      </div>
    </div>
  );
};

export { Achievements };
export default Achievements;
